
const conversionRates = (state = {
  rates: {
    BTCUSD: 0,
    BTCEUR: 0,
  },
  lastUpdated: null,
}, action) => {
  switch (action.type) {
    case 'SET_CONVERSION_RATES':
      return {
        ...state,
        rates: {
          ...action.conversionRates
        },
        lastUpdated: action.receivedAt
      };
    default:
      return state
  }
};


export default conversionRates



// WEBPACK FOOTER //
// ./src/Reducers/conversionRates.js